var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-insert"},[_c('h4',[_vm._v(_vm._s(_vm.L10n('add-new')))]),_c('form-editor',{ref:"Form",attrs:{"data":_vm.data,"model":_vm.formModel,"list":_vm.list},on:{"command":_vm.commandController}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }